const useDataLayer = () => {
  const sendDataToDataLayer = (data) => {
    // console.log("[GA4] Event tracked >> ", data)
    window.dataLayer.push(data);
  };

  return {
    sendDataToDataLayer,
  };
};

export default useDataLayer;
